<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" class="mt-5 mr-5" color="primary" elevation="2" fab small><v-icon>mdi-plus</v-icon></v-btn>
    </template>
    <v-list>
      <v-list-item @click="$emit('addType', { mode: 'addDate', type: $const.eventType.CLOSING })">
        <v-list-item-title class="AddTypeButton-title primary--text">
          <v-icon :color="color" left>mdi-plus</v-icon>{{ $t('exceptionalClosure.addDateButton') }}
        </v-list-item-title>
      </v-list-item>
      <v-divider />
      <v-list-item @click="$emit('addType', { mode: 'addDateRange', type: $const.eventType.CLOSING })">
        <v-list-item-title :class="`AddTypeButton-title primary--text`">
          <v-icon :color="color" left>mdi-plus</v-icon>{{ $t('exceptionalClosure.addDateRangeButton') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'AddTypeButton',
  computed: {
    color() {
      return this.$site === this.$const.sites.galileo ? 'primaryAccent' : 'primary'
    }
  }
}
</script>

<style scoped lang="scss">
.AddTypeButton-title {
  font-weight: 700;
}
</style>

<style lang="scss">
.App-galileo .AddTypeButton-title {
  color: var(--v-primaryAccent-base) !important;
}
</style>
